module.exports = __webpack_public_path__ + "img/down-anhui3.f28d900d.jpg";